import FmStorageTableDto from 'app/admin/fileManager/dto/FmStorageTableDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class FmStorageTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'fmStorageTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<FmStorageTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, FmStorageTableDto)))
				.catch(reject);
		});
	}
}

export default new FmStorageTableService();
